import React from "react";
import styles from "./CustomSelect.module.scss";
import ErrorHandler from "../ErrorHandler/ErrorHandler.component";
import { renderBadge } from "./helpers";

const CustomSelectDropdown = ({
  name,
  reference,
  children,
  label,
  errors,
  value,
  onChange,
  iconType,
  readOnly,
  className,
  disabled,
  isShowBadge = false,
  badgeText = null,
  defaultValue,
}) => {
  return (
    <>
      <div className={`form-group ${styles.customSelect}`}>
        {!isShowBadge ? (
          <label>
            {iconType ? <i className={iconType} /> : ""}
            {label}
          </label>
        ) : (
          <label className={styles.customLabelWithBadge}>
            <span>
              {iconType ? <i className={iconType} /> : ""}
              {label}
            </span>
            {badgeText && renderBadge(badgeText)}
          </label>
        )}

        <select
          className={`${styles.selectBox} ${className}`}
          name={name}
          ref={reference}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          disabled={disabled}
          defaultValue={defaultValue}
        >
          {children}
        </select>
      </div>
      <ErrorHandler errors={errors} />
    </>
  );
};

export default CustomSelectDropdown;
